import ResourceTyped from './ResourceTyped';

class ContactScraper extends ResourceTyped<any> {
	constructor() {
		super('contactScraper');
	}

	start(clientIds: number[]) {
		return this._postRequest('start', { clientIds });
	}

	getRecentlySearched(): Promise<{ data: { error: null; data: { clientIds: number[] } } }> {
		return this._getRequest('recentlySearched', { methodName: 'getRecentlySearched' });
	}

	getActiveRun() {
		return this._getRequest('runs/active', { methodName: 'getActiveRun' });
	}

	cancelRun(runId: number) {
		return this._postRequest(`runs/${runId}/cancel`, {}, { methodName: 'cancelRun' });
	}

	resumeRun(runId: number) {
		return this._postRequest(`runs/${runId}/resume`, {}, { methodName: 'resumeRun' });
	}
}

export default new ContactScraper();
